function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgStaff = function SvgStaff(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 26.541 19.9",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M23.5 0H3.041A3.043 3.043 0 0 0 0 3.041v13.822A3.043 3.043 0 0 0 3.041 19.9H23.5a3.043 3.043 0 0 0 3.041-3.041V3.041A3.043 3.043 0 0 0 23.5 0",
    style: {
      strokeWidth: 0,
      fill: "#fcfcfc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.59 7.02a2.6 2.6 0 1 1-2.6-2.6 2.6 2.6 0 0 1 2.6 2.6M12.667 14.032a.78.78 0 0 1-.779.779H4.097a.78.78 0 0 1-.779-.779v-.519a2.86 2.86 0 0 1 2.857-2.857h3.636a2.86 2.86 0 0 1 2.857 2.857z",
    style: {
      strokeWidth: 0,
      fill: "#f08d00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.082 10.657V7.518a3.139 3.139 0 1 0 3.139 3.139z",
    style: {
      fill: "#dbe4f1",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m22.121 7.826.3-.3a.278.278 0 0 0-.392-.392l-.309.309a4.14 4.14 0 0 0-2.08-.907v-.495h-1.111v.5a4.14 4.14 0 0 0-2.08.907l-.309-.309a.278.278 0 0 0-.392.392l.3.3a4.153 4.153 0 1 0 6.075 0zm-3.038 6.246a3.415 3.415 0 1 1-.001-6.831 3.415 3.415 0 0 1 .001 6.831",
    style: {
      strokeWidth: 0,
      fill: "#248bcc"
    }
  }));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgStaff);
export default ForwardRef;